import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsDefined,
  ArrayMinSize,
  IsArray,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { UserCreateDto } from './user-create.dto';

export const USER_RELATION_MAX_ITEMS = 100;

/**
 * Body of POST /user/provision: the user and the full set of roles and
 * regions it starts with, persisted in one transaction.
 */
export class UserProvisionDto {
  @ApiProperty({ type: () => UserCreateDto })
  @Expose()
  @IsDefined()
  @ValidateNested()
  @Type(() => UserCreateDto)
  user!: UserCreateDto;

  @ApiProperty({
    type: [String],
    format: 'uuid',
    description: 'Role ids the user starts with (at least one).',
  })
  @Expose()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(USER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  roleIds!: string[];

  @ApiProperty({
    type: [String],
    format: 'uuid',
    description: 'Region ids the user starts with (may be empty).',
  })
  @Expose()
  @IsArray()
  @ArrayMaxSize(USER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds!: string[];
}
